var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row m-b-md"},[(_vm.clientsMutable.length > 0)?_c('span',{staticClass:"font-bold"},[_vm._v("Neu in: ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.clientsMutable),function(client){return _c('span',{staticClass:"badge badge-primary m-l-xs",domProps:{"textContent":_vm._s(client)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }